import React, { useState } from "react";
import { object, string } from "yup";
import * as yup from "yup";

const parseDate = (dateStr) => {
  if (!dateStr) return null;

  const clean = dateStr.trim();
  const [day, month, year] = clean.split("/").map(Number);

  if (!day || !month || !year) return null;

  return new Date(year, month - 1, day);
};


const useModalInfosAdicionais = () => {
  const validation = object({
    dataInicioVigencia: string()
      .matches(
        /^(0[1-9]|[12][0-9]|3[01])[/](0[1-9]|1[0-2])[/](19|20)\d\d$/,
        "Insira uma data válida no formato dd/mm/aaaa"
      )
      .required("Campo obrigatório"),
    dataFimVigencia: string()
      .matches(
        /^(0[1-9]|[12][0-9]|3[01])[/](0[1-9]|1[0-2])[/](19|20)\d\d$/,
        "Insira uma data válida no formato dd/mm/aaaa"
      )
      .required("Campo obrigatório")
      .test("date-check", "A data final não pode ser menor que a data inicial", function (value) {
        const { dataInicioVigencia } = this.parent;
        const inicio = parseDate(dataInicioVigencia);
        const fim = parseDate(value);

        if (!inicio || !fim) return true;

        return fim >= inicio;
      })
      .test(
        "max-1-ano",
        "A data de fim deve ser no máximo 1 ano após a data de início",
        function (value) {
          const { dataInicioVigencia } = this.parent;
          const inicio = parseDate(dataInicioVigencia);
          const fim = parseDate(value);

          if (!inicio || !fim) return true;

          const limite = new Date(inicio);
          limite.setFullYear(limite.getFullYear() + 1);

          return fim <= limite;
        }
      ),
    justificativa: yup.string().required("Campo obrigatório"),
  });

  const [initial, setInitial] = useState({
    dataInicioVigencia: null,
    dataFimVigencia: null,
    textoCurto: null,
    justificativa: null,
  });

  return {
    initial,
    validation,
  };
};

export default useModalInfosAdicionais;
